import { linkToDashboardByUser } from './link-to-dashboard';

/**
 * Returns the link to the homepage that is different depending on the user region state
 * @param {object} userRegion - current user region
 * @return {string} the path to the homepage
 */
export default function linkToHome(userRegion) {
    return linkToDashboardByUser(userRegion);
}



// WEBPACK FOOTER //
// ./mcart/assets/src/js/app/util/misc/link-to-home.js